"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLocationTimeZone = exports.useLocationTimeZone = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
function useLocationTimeZone(locationId) {
    var _a, _b, _c;
    const res = client_1.useQuery(TIME_ZONE_QUERY, {
        variables: {
            locationId: locationId,
        },
        context: { locationId },
        skip: locationId === null,
    });
    if ((_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.timeZone) === null || _c === void 0 ? void 0 : _c.stringValue) {
        const raw = res.data.location.timeZone.stringValue;
        return {
            raw,
            location: getLocationTimeZone(raw),
            timeScaleDB: getTimeScaleDBTimeZone(raw),
        };
    }
    return null;
}
exports.useLocationTimeZone = useLocationTimeZone;
const TIME_ZONE_QUERY = graphql_tag_1.default `
  query TimeZoneLocationQuery($locationId: String!) {
    location(locationId: $locationId) {
      key
      locationId
      timeZone: property(name: timeZone) {
        stringValue
      }
    }
  }
`;
function getLocationTimeZone(whateverTimeZone) {
    switch (whateverTimeZone) {
        case 'Central Europe Standard Time':
            return 'Europe/Stockholm';
        default:
            return null;
    }
}
function getTimeScaleDBTimeZone(whateverTimeZone) {
    switch (whateverTimeZone) {
        case 'E. Australia Standard Time':
            return 'Australia/Melbourne';
        case 'Cen. Australia Standard Time':
            return 'Australia/Adelaide';
        case 'W. Australia Standard Time':
            return 'Australia/Perth';
        case 'Tokyo Standard Time':
            return 'Asia/Tokyo';
        case 'UTC':
            return 'UTC';
        case 'Central Europe Standard Time':
            return 'Europe/Stockholm';
        case 'US Eastern Standard Time':
            return 'US/Eastern';
        case 'Central Standard Time':
            return 'US/Central';
        case 'Mountain Standard Time':
            return 'US/Mountain';
        case 'Pacific Standard Time':
            return 'US/Pacific';
        default:
            return whateverTimeZone;
    }
}
function mockLocationTimeZone(locationId, timeZone) {
    return {
        request: {
            query: TIME_ZONE_QUERY,
            variables: { locationId },
        },
        result: {
            data: {
                location: {
                    key: locationId,
                    locationId,
                    timeZone: {
                        key: 'timeZone',
                        stringValue: timeZone,
                    },
                },
            },
        },
    };
}
exports.mockLocationTimeZone = mockLocationTimeZone;
//# sourceMappingURL=useLocationTimeZone.js.map